// extracted by mini-css-extract-plugin
export default {"post-info":"PostInfo_post-info__kmL9P","post-info__user":"PostInfo_post-info__user__4JOGz"};